import GradientDot from '../GradientDot/GradientDot';
import CountUpValue from '../CountUpValue/CountUpValue';
import ActionButton from '../ActionButton/ActionButton';
import './InitiativeSummary.css';

export default function InitiativeSummary({
  count = 0,
  topTitle,
  bottomTitle,
  buttonLabel,
  onButtonClick,
}) {
  return (
    <div className="InitiativeSummary">
      {topTitle ? <div className="InitiativeSummary__topTitle">{topTitle}</div> : null}
      <div className="InitiativeSummary__dial">
        <span className="InitiativeSummary__ring" />
        <span className="InitiativeSummary__ring InitiativeSummary__ring--inner" />
        <img
          className="InitiativeSummary__zigzag InitiativeSummary__zigzag--left"
          src={`${process.env.PUBLIC_URL}/left-zig-zag.svg`}
          alt=""
          aria-hidden="true"
        />
        <img
          className="InitiativeSummary__zigzag InitiativeSummary__zigzag--right"
          src={`${process.env.PUBLIC_URL}/right-zig-zag.svg`}
          alt=""
          aria-hidden="true"
        />
        <GradientDot className="InitiativeSummary__dot InitiativeSummary__dot--left" size={10} />
        <GradientDot className="InitiativeSummary__dot InitiativeSummary__dot--right" size={10} />
        <div className="InitiativeSummary__count">
          <CountUpValue value={count} className="InitiativeSummary__countValue" />
        </div>
      </div>
      {bottomTitle ? <div className="InitiativeSummary__topTitle">{bottomTitle}</div> : null}
      <ActionButton label={buttonLabel} onClick={onButtonClick} />
    </div>
  );
}
